export default {
  components: {},
  data() {
    return {}
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/blue-slider-block-items/component.js